import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { a as createLogger, u as updateElementStyle, d as isNumber, f as isUnset, n as numToRem } from './utils.js';

// Constants
const component = 'cl-pictogram';

const clPictogramCss = ".sc-cl-pictogram-h,.sc-cl-pictogram-h span.sc-cl-pictogram,.sc-cl-pictogram-h svg.sc-cl-pictogram,.sc-cl-pictogram-h slot-fb.sc-cl-pictogram,.sc-cl-pictogram-h span.sc-cl-pictogram-s>*{display:block;height:var(--custom-pictogram-size, var(--pictogram-size, calc(28 * var(--size-1))));max-height:100%;max-width:100%;width:var(--custom-pictogram-size, var(--pictogram-size, calc(28 * var(--size-1))))}.sc-cl-pictogram-h span.sc-cl-pictogram-s>*:not(:last-child){display:none}.sc-cl-pictogram-h span.sc-cl-pictogram-s>*:last-child{display:block}";

const ClPictogram = /*@__PURE__*/ proxyCustomElement(class ClPictogram extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    /**
     * Object containing custom consoleLogger functions.
     */
    this.logger = createLogger(component);
    this.ariaLabel = '';
    this.name = '';
    this.size = undefined;
  }
  /**
   * Validates the size property and updates the styles accordingly
   */
  handleSize(size) {
    const cssVariable = '--custom-pictogram-size';
    switch (true) {
      case isUnset(size):
        updateElementStyle(this.element, undefined, cssVariable);
        break;
      case !isNumber(size):
        this.logger.error.attribute.size(`Given invalid value "${size}".`);
        break;
      default:
        updateElementStyle(this.element, numToRem(size), cssVariable);
        break;
    }
  }
  /**
   * Every time the component is connected to the DOM:
   * - Validate the size attribute and update the styles;
   */
  connectedCallback() {
    this.handleSize(this.size);
  }
  render() {
    const { ariaLabel, name } = this;
    return (h("span", Object.assign({}, (ariaLabel ? { 'aria-label': ariaLabel } : {})), h("slot", null, (name === null || name === void 0 ? void 0 : name.length) ? (h("svg", null, h("use", { height: '100%', href: `#${name}`, width: '100%' }))) : null)));
  }
  get element() { return this; }
  static get watchers() { return {
    "size": ["handleSize"]
  }; }
  static get style() { return clPictogramCss; }
}, [6, "cl-pictogram", {
    "ariaLabel": [1, "aria-label"],
    "name": [1],
    "size": [2]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["cl-pictogram"];
  components.forEach(tagName => { switch (tagName) {
    case "cl-pictogram":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ClPictogram);
      }
      break;
  } });
}

export { ClPictogram as C, defineCustomElement as d };

//# sourceMappingURL=cl-pictogram2.js.map